module.exports = "#version 300 es\r\nprecision highp float;\r\n\r\n// The vertex shader used to render the background of the scene\r\n\r\nin vec4 vs_Pos;\r\n\r\nvoid main() {\r\n  gl_Position = vs_Pos;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/flat-vert.glsl
// module id = 71
// module chunks = 0